"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../utils/styles/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : GROUP : STYLES --------------- ++++++++++ */


var _default = {
  group: {
    // ----- variants ----- //
    '&.variant-raised': {
      // background: theme.color.light.light.swatch,
      boxShadow: _index.theme.boxShadow.small,
      borderRadius: (0, _index.pxToEm)(5)
    },
    '&.variant-outline': {
      borderRadius: (0, _index.pxToEm)(5),
      border: (0, _index.replacePXinStringWithEM)("1px solid ".concat(_index.theme.color.neutral.medium.swatch))
    },
    // ----- types ----- //
    '&.type-fields': {
      '& .field': {
        marginRight: (0, _index.pxToEm)(40),
        '&:last-child': {
          marginRight: '0'
        }
      }
    },
    '&.type-radiobuttons': {
      '& .field': {
        '& .label': {
          color: "rgba(6, 43, 117, 0.5)"
        }
      }
    },
    // ----- colors ----- //
    // generates classes for every color in the theme ".color-(uniqueColor)"
    extend: [_index.classStyleHelper.direction, _index.classStyleHelper.align, (0, _index.themeStyleHelper)(_index.theme, 'color', function (theme, uniqueColor) {
      return {
        background: theme.color[uniqueColor].medium.swatch,
        color: theme.color[uniqueColor].medium.contrast
      };
    })]
  }
};
exports.default = _default;